module.exports = __webpack_public_path__ + "img/certificate-1-2.76b5b5fd.jpg";